import React from 'react';
import { FaCheck, FaClock } from 'react-icons/fa';
import { getAvailableHoursForDate } from '../../utils/dateUtils';

const TimeSlotSelector = ({
  selectedTime,
  onTimeSelect,
  occupiedTimes = [],
  selectedDate,
  disabled = false,
  className = ""
}) => {
  const isTimeOccupied = (time) => occupiedTimes.includes(time);
  const isTimeSelected = (time) => selectedTime === time;

  // Obtener horarios según el día seleccionado
  const availableHours = selectedDate ? getAvailableHoursForDate(selectedDate) : [
    '10:00', '10:30', '11:00', '11:30',
    '12:00', '12:30', '13:00', '13:30', '14:00', '14:30',
    '15:00', '15:30', '16:00', '16:30', '17:00', '17:30',
    '18:00', '18:30', '19:00'
  ];

  console.log('🔍 TimeSlotSelector Debug:', {
    selectedDate: selectedDate,
    availableHours: availableHours,
    availableHoursLength: availableHours.length
  });

  // Si no hay horarios disponibles, mostrar mensaje
  if (availableHours.length === 0) {
    return (
      <div className={`text-center py-8 text-gray-500 ${className}`}>
        <div className="text-lg font-medium mb-2">No hay horarios disponibles</div>
        <div className="text-sm">Este día no se atiende</div>
      </div>
    );
  }

  return (
    <div className={`grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2 ${className}`}>
      {availableHours.map((time) => {
        const isOccupied = isTimeOccupied(time);
        const isSelected = isTimeSelected(time);
        
        return (
          <button
            key={time}
            onClick={() => !isOccupied && !disabled && onTimeSelect(time)}
            disabled={isOccupied || disabled}
            className={`
              p-3 rounded-lg text-sm font-medium transition-all duration-200
              ${isSelected 
                ? 'bg-indigo-600 text-white shadow-lg scale-105' 
                : isOccupied 
                  ? 'bg-gray-200 text-gray-500 cursor-not-allowed opacity-60' 
                  : 'bg-white text-gray-700 border border-gray-300 hover:bg-indigo-50 hover:border-indigo-300 hover:scale-105'
              }
              ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
            `}
          >
            <div className="flex items-center justify-center gap-1">
              {isSelected ? (
                <FaCheck className="w-3 h-3" />
              ) : (
                <FaClock className="w-3 h-3" />
              )}
              <span>{time}</span>
            </div>
            {isOccupied && (
              <div className="text-xs mt-1 text-red-500">
                Ocupado
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default TimeSlotSelector; 